export default "__VITE_ASSET__CMO6nnnv__"